import { call, put } from 'redux-saga/effects';
import { getBankAccountSuccess, getBankAccountFailure } from '../redux/actions';
import { getBankAccounts } from 'modules/Profile/services/API';

export function* getBankSaga({ payload }) {
  const { isOk, data, error } = yield call(getBankAccounts, payload);
  if (isOk && data) {
    const options = data.content
      .filter(({ status }) => status === 'Y')
      .map(({ bik, bankName, accountNumber }) => ({
        label: `${accountNumber} - ${bankName}`,
        value: accountNumber,
        bank: bankName,
        bik,
      }));
    yield put(getBankAccountSuccess(options));
  } else {
    yield put(getBankAccountFailure(error));
  }
}
